<template>
  <div>
    <a :href="link">
      <ProductImage :resolutions="resolutions" :isNew="isNew"
                    :language="language"
                    :sizes="sizes"
                    :alt="alt"/>
    </a>
  </div>
</template>

<script>
import ProductImage from '@/variety-advisor/components/product-image.vue';

export default {
  name: 'ProductImageLink',
  components: { ProductImage },
  props: {
    resolutions: {
      type: Object,
      required: true,
    },
    sizes: String,
    link: String,
    isNew: Boolean,
    language: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>
